import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import {
  ThfButtonModule,
  ThfContainerModule,
  ThfDialogModule,
  ThfDividerModule,
  ThfDynamicModule,
  ThfFieldModule,
  ThfInfoModule,
  ThfPageModule,
  ThfStepperModule,
  ThfWidgetModule
} from '@totvs/thf-ui';

import { ThfPageJobSchedulerComponent } from './thf-page-job-scheduler.component';
import { ThfPageJobSchedulerExecutionComponent } from './thf-page-job-scheduler-execution/thf-page-job-scheduler-execution.component';
import { ThfPageJobSchedulerLookupService } from './thf-page-job-scheduler-lookup.service';
import { ThfPageJobSchedulerParametersComponent } from './thf-page-job-scheduler-parameters/thf-page-job-scheduler-parameters.component';
import { ThfPageJobSchedulerService } from './thf-page-job-scheduler.service';
import { ThfPageJobSchedulerSummaryComponent } from './thf-page-job-scheduler-summary/thf-page-job-scheduler-summary.component';

@NgModule({
  declarations: [
    ThfPageJobSchedulerComponent,
    ThfPageJobSchedulerExecutionComponent,
    ThfPageJobSchedulerParametersComponent,
    ThfPageJobSchedulerSummaryComponent
  ],
  exports: [
    ThfPageJobSchedulerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ThfButtonModule,
    ThfContainerModule,
    ThfDialogModule,
    ThfDividerModule,
    ThfDynamicModule,
    ThfFieldModule,
    ThfInfoModule,
    ThfPageModule,
    ThfStepperModule,
    ThfWidgetModule
  ],
  providers: [
    ThfPageJobSchedulerService,
    ThfPageJobSchedulerLookupService
  ]
})
export class ThfPageJobSchedulerModule { }
